module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00001.865346f2.jpg";